<template>
  <StTooltip trigger="hover" placement="top" no-teleport>
    <template #activator>
      <div
        data-t="favorite-button"
        class="favorite-icon-wrapper"
        :class="favoriteIconClass"
        @click.prevent="handleFavoriteClick"
      >
        <div class="inner-wrapper">
          <StIcon
            class="icon"
            :class="{ 'favorite-icon': isFavorite }"
            :name="isFavorite ? 'heart-solid' : 'heart'"
            :size="20"
          />
        </div>
      </div>
    </template>
    <p class="tooltip-text">
      {{ favoriteTooltipText }}
    </p>
  </StTooltip>
</template>

<script setup lang="ts">
const isFavorite = defineModel<boolean>()
const { t } = useI18n()
function handleFavoriteClick() {
  isFavorite.value = !isFavorite.value
}

const favoriteIconClass = computed(() => [
  { shake: isFavorite.value },
  { 'favorite-icon-active': isFavorite.value },
])

const favoriteTooltipText = computed(() =>
  isFavorite.value
    ? t('casino.showAllGames')
    : t('casino.favoriteGamesTooltip'),
)
</script>

<style scoped>
.favorite-icon-wrapper {
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  width: 32px;
  height: 32px;

  background-color: var(--background-secondary);
  border-radius: var(--border-radius-100);

  .inner-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: var(--spacing-050);
  }

  .icon {
    min-width: 0;
    background-color: var(--icon-secondary);
    transition: background-color 0.2s ease-in-out;
  }

  &:hover .icon {
    background-color: var(--icon-primary);
  }

  &.shake {
    .inner-wrapper {
      animation: shake 0.3s ease-in-out;
    }
  }

  &.favorite-icon-active {
    .inner-wrapper {
      transition: background-color 0.2s ease-in-out;
    }

    .icon {
      background-color: #fb1038; /* stylelint-disable-line */
    }

    &:hover {
      .icon {
        background-color: #fb1038; /* stylelint-disable-line */
      }
    }
  }

  &.mobile {
    position: absolute;
    z-index: 2;
    right: 0;
    margin: var(--spacing-025);
  }
}

.tooltip-text {
  margin: 0;
  padding: var(--spacing-100) var(--spacing-150);
  font: var(--desktop-text-xs-medium);
}

@keyframes shake {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.2);
  }

  100% {
    transform: scale(1);
  }
}
</style>
